module.exports = __webpack_public_path__ + "img/ıkas.c9d34086.jpg";